import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { BaseApiService } from '../baseApiService';
import { AuthenticationService } from '../../auth/authentication-service';
import { OfferingTree } from './offeringTree';

@Injectable({
  providedIn: 'root'
})
export class OfferingTreeApiService extends BaseApiService {
  constructor(http: HttpClient, authService: AuthenticationService) {
    super(http, authService);
  }

  getOfferingTreeNode(parentCid: string, withChildren: boolean): Observable<OfferingTree[]> {
    return this.http.get<OfferingTree[]>(`${this.apiUrl}/api/v5/offering-tree?ParentCid=${parentCid}&AddChildrenToResponse=${withChildren}`).pipe(
      catchError(this.handleError<OfferingTree[]>('getSite', undefined))
    );
  }
}
